import { render } from "./VistaContratoView.vue?vue&type=template&id=1d95f1d6"
import script from "./VistaContratoView.vue?vue&type=script&lang=js"
export * from "./VistaContratoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__